import styled, { css } from "styled-components";
import { minQuery, maxQuery } from "utils/responsivenessHelper";
import colours from "assets/colours";

const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: ${(props) => props.alignItems || "unset"};
  justify-content: ${(props) => props.justifyContent || "unset"};
  align-self: ${(props) => props.alignSelf || "unset"};
  margin-left: ${(props) => props.ml || "unset"};

  ${({ nowrap }) =>
    nowrap &&
    css`
      flex-wrap: unset;
    `};

  ${({ p }) =>
    p &&
    css`
      padding: ${p};
    `};

  ${({ m }) =>
    m &&
    css`
      margin: ${m};
    `};

  ${({ xs, sm, md, lg, xl }) => {
    sm = sm || xs;
    md = md || sm || xs;
    lg = lg || md || sm || xs;
    xl = xl || lg || md || sm || xs;

    return (
      (xs || sm || md || lg || xl) &&
      css`
        /** extra small */
        @media (min-width: 0px) {
          flex: ${xs};
          flex-basis: ${(xs / 12) * 100 + "%"};
        }

        /** small */
        @media (min-width: 576px) {
          flex: ${sm};
          flex-basis: ${(sm / 12) * 100 + "%"};
        }

        /** medium */
        @media (min-width: 768px) {
          flex: ${md};
          flex-basis: ${(md / 12) * 100 + "%"};
        }

        /** large */
        @media (min-width: 992px) {
          flex: ${lg};
          flex-basis: ${(lg / 12) * 100 + "%"};
        }

        /** extra large */
        @media (min-width: 1200px) {
          flex: ${xl};
          flex-basis: ${(xl / 12) * 100 + "%"};
        }
      `
    );
  }}
`;

const Row = styled(FlexContainer)`
  flex-direction: row;
  width: 100%;
`;

const Col = styled(FlexContainer)`
  flex-direction: column;
`;

const LineBreak = styled.br`
  display: flex;
  ${({ minW }) =>
    minW &&
    css`
      display: none;
      ${minQuery.both({ display: "flex" }, minW)};
    `}

  ${({ maxW }) =>
    maxW &&
    css`
      display: none;
      ${maxQuery.both({ display: "flex" }, maxW)};
    `}
`;

const styledScroll = css`
  scrollbar-color: ${colours.grey4};
  scrollbar-width: thin;

  ::-webkit-scrollbar {
    width: 5px;
    height: 0px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px ${colours.grey4};
    border-radius: 10px;
    margin: 0px 10px 40px 0px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px ${colours.grey2};
  }
`;

export { Row, Col, LineBreak, styledScroll };
